import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';

export const ScrollToTop = () => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 420);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    return (
        <button
            type="button"
            data-testid="floating-scrolltop-button"
            aria-label="Volver arriba"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className={cn(
                'fixed z-40 right-6 sm:right-8 bottom-24 sm:bottom-28 size-12 rounded-full bg-gradient-fun text-white shadow-pop ring-2 ring-white/70 flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95',
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none'
            )}
        >
            <ArrowUp className="size-5" />
        </button>
    );
};

export default ScrollToTop;
